import { ApplyWheelHouseWrapper } from "./styles"
import { useTranslation } from "react-i18next"
import CustomButton from "@Common/CustomButton"
import WheelHouseLarge from "@assets/svg/wheelHouse_large.svg?react"
import { IoClose } from "react-icons/io5"
import { Dispatch, SetStateAction } from "react"
import CircularProgress from "@mui/material/CircularProgress"
interface IProps {
	closePopUp: () => void
	isLoaderOpen: boolean
}
export default function ApplyWheelHouse({ closePopUp, isLoaderOpen }: IProps) {
	const { t } = useTranslation()
	return (
		<ApplyWheelHouseWrapper>
			<div>
				<div onClick={() => closePopUp()}>
					<IoClose />
				</div>
				<div>
					<WheelHouseLarge />
				</div>
				<div>
					{t("CALENDAR.Are you sure you want to apply changes")}
				</div>
				<div>
					<CustomButton
						label={!isLoaderOpen ? t("CALENDAR.yes") : ""}
						customPadding='16px 24px'
						customBG='#5B3FFF'
						customColor='#fff'
						type='submit'
						form='wheelhousesettingform'
						withIcone
						customIcon={
							isLoaderOpen ? (
								<CircularProgress color='inherit' size='20px' />
							) : undefined
						}
					/>
				</div>
			</div>
		</ApplyWheelHouseWrapper>
	)
}
